import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import type { RootState, AppDispatch } from "./store";

export const useIADispatch = () => useDispatch<AppDispatch>();
export const useIASelector: TypedUseSelectorHook<RootState> = useSelector;
